<template>
    <LayoutList>
        <template slot="header" v-if="resource">
            <h1>{{ resource.activityName || '&nbsp;' }}</h1>

            <router-link :to="{ name: 'create-activity', params: {
                event_id: resource.eventId,
                start: resource.end,
            } }" class="btn btn--primary">
                Add Another
            </router-link>
            <button @click="showDeleteModal()" class="btn btn--danger">
                Delete Activity
            </button>
            <router-link :to="{ name: 'edit-activity', params: { event_id: resource.eventId, id: resource.activity_id } }" class="btn btn--outline">
                Edit
            </router-link>
            <div v-if="resource.activityTypeFormatted === ActivityTypes.MEALS || resource.registrable === true">
                <button class="btn btn--activity-registrations btn--primary" @click="createRegistrations()">Create Registrations</button>
            </div>

            <!--            <router-link :to="stepLink()" class="btn">Edit</router-link>-->
        </template>
        <section class="activity-info">
            <ul class="grid post-details">
                <li v-if="resource.start" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">Start Date</span>
                    <span>{{ resource.start.displayDate }}, {{ resource.start.displayTime }}</span>
                </li>
                <li v-if="resource.end" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">End Date</span>
                    <span>{{ resource.end.displayDate }}, {{ resource.end.displayTime }}</span>
                </li>
                <li v-if="resource.activityLocation" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">Location</span>
                    <span>{{ resource.activityLocation }}</span>
                </li>
                <li v-if="resource.activityRoom" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">Room</span>
                    <span>{{ resource.activityRoom }}</span>
                </li>
                <li v-if="resource.activityTypeFormatted" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">Activity Type</span>
                    <span>{{ resource.activityTypeFormatted }}</span>
                </li>
            </ul>
        </section>

        <section class="location-info">
            <ul class="grid post-details">
                <li v-if="resource.rating" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">Rating</span>
                    <span>{{ resource.rating }}</span>
                </li>
                <li v-if="resource.website" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">Website</span>
                    <span><a :href="resource.website" target="_blank">Visit Website</a></span>
                </li>
                <li v-if="resource.phoneNumber" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">Phone Number</span>
                    <span>
                        {{ resource.phoneNumber }}
                    </span>
                </li>
                <li v-if="resource.directionUrl" class="col-12 col-md-2 col-bleed-y detail">
                    <span class="label">Directions</span>
                    <span><a :href="resource.directionUrl" target="_blank">Get Directions</a></span>
                </li>
            </ul>
        </section>
        <section class="grid">
            <div class="col-12 col-md-8">
                <div class="card" v-if="resource.activityDescription">
                    <div class="header">Description</div>
                    <div v-html="resource.activityDescription"></div>
                </div>
                <div class="card" v-if="resource.activityBackgroundImage">
                    <div class="header">Background Image</div>
                    <img :src="resource.activityBackgroundImage" alt="Background Image" style="max-width: 100%;">
                </div>
            </div>
            <div v-if="resource.chairPeople">
                <h2>Chair People</h2>
                <ul class="grid">
                    <li v-for="person in resource.chairPeople" class="col-12">
<!--                        <PersonCard :currPerson="person" />-->
                    </li>
                </ul>
            </div>
        </section>
    </LayoutList>
</template>

<script>
    import ResourceView from '../../ResourceView';
    import SvgIcon from '../../SvgIcon.vue';
    import LayoutList from '@layouts/LayoutList.vue';
    import API from '../../../api';
    import { gmapApi } from 'vue2-google-maps';
    import { ActivityTypes } from '../../../resources/ActivityTypes';

    export default {
        name: "ActivityView",
        mixins: [ResourceView],
        components: {
            SvgIcon,
            LayoutList,
        },
        watch: {
            id: function (newVal, oldVal) {
                return API.getMember(newVal).then(response => {
                    console.log("[MemberView.vue] - ", response);
                    this.resource = response;
                    this.peopleFilters.member = newVal;
                    this.oppFilters.member = newVal;
                    this.maddFilters.member = newVal;
                    this.intFilters.member = newVal;
                    this.insFilters.member = newVal;
                });
            }
        },
        data() {
            return {
                resource: {
                    id: -1,
                    activityName: '',
                    activityDescription: '',
                    activityLocation: '',
                    activityRoom: '',
                    activityTypeFormatted: '',
                    registrable: false,
                    rating: 0.0,
                    website: '',
                    phoneNumber: '',
                    directionUrl: '',
                    eventId: 0,
                    lat: 0.0,
                    lng: 0.0,
                    chairPeople: [],
                    showDate: true,
                    start: {
                        displayDate: '',
                        displayTime: '',
                    },
                    end: {
                        displayDate: '',
                        displayTime: '',
                    },
                    activityBackgroundImage: '',
                    activities: [],
                },
                deleteModal: {
                    title: 'Are you sure you want to delete this Activity?',
                    buttonLabel: 'Delete Activity',
                },
                ActivityTypes: ActivityTypes,
            }
        },
        computed: {
            google: gmapApi,
        },
        methods: {
            stepLink() {
                return { name: 'edit-member-step', params: { step: 1, event_id: this.resource.eventId }}
            },
            fetchResource() {
                return API.getActivity(this.id);
            },
            createRegistrations() {
                return API.createMealRegistrations(this.id);
            },
            deleteResource() {
                return API.deleteActivity(this.id).then((response) => {
                    console.log(response);
                    console.log("navigate to view event with id: ", this.resource.eventId)
                    this.$router.push({ name: `view-event`, params: { event_id: this.resource.eventId.toString() }});
                });
            },
            showDeleteModal() {
                this.$modal.show('dialog', {
                    title: this.deleteModal.title,
                    text: this.deleteModal.content,
                    buttons: [
                        {
                            class: 'btn btn--danger',
                            title: this.deleteModal.buttonLabel,
                            handler: () => {
                                this.deleteResource();
                            }
                        },
                    ]
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .btn--activity-registrations {
        margin-left: 2rem;
    }
</style>
<script setup>
import { ActivityTypes } from '../../../resources/ActivityTypes';
</script>
